/* MOMENTUM — global.js */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var scrim = document.querySelector('[data-drawer-scrim]');
    var openBtn = document.querySelector('[data-drawer-open]');
    var closeBtn = document.querySelector('[data-drawer-close]');
    if (!drawer || !openBtn || openBtn.dataset.bound === 'true') return;

    function openDrawer() {
      drawer.hidden = false;
      scrim.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        scrim.classList.add('is-open');
      });
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        drawer.hidden = true;
        scrim.hidden = true;
      }, 260);
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    openBtn.dataset.bound = 'true';
  }

  /* ---------- Drawer accordions ---------- */
  function initAccordions(scope) {
    scope.querySelectorAll('[data-accordion]').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        sub.hidden = expanded;
        var chev = btn.querySelector('.mobile-drawer__chevron');
        if (chev) chev.textContent = expanded ? '+' : '−';
      });
      btn.dataset.bound = 'true';
    });
  }

  /* ---------- Mega menu: keyboard + touch support ---------- */
  function initMegaMenus(scope) {
    scope.querySelectorAll('[data-mega-parent]').forEach(function (item) {
      if (item.dataset.bound === 'true') return;
      var link = item.querySelector('.site-nav__link');
      var panel = item.querySelector('[data-mega-panel]');
      if (!link || !panel) return;

      item.addEventListener('mouseenter', function () {
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        link.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          panel.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
        }
      });

      item.dataset.bound = 'true';
    });
  }

  /* ---------- Product page: sync option pills -> variant select ---------- */
  function initProduct(scope) {
    var variantSelect = scope.querySelector('[data-variant-select]');
    if (!variantSelect || variantSelect.dataset.bound === 'true') return;

    var priceEl = scope.querySelector('[data-price]');
    var pillInputs = scope.querySelectorAll('.option-pills input[type="radio"]');

    function syncVariant() {
      var selected = [];
      scope.querySelectorAll('.product-page__option').forEach(function (opt) {
        var checked = opt.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var options = Array.prototype.slice.call(variantSelect.options);
      var match = options.find(function (o) {
        try {
          var vals = JSON.parse(o.dataset.options || '[]');
          return vals.length === selected.length && vals.every(function (v, i) { return v === selected[i]; });
        } catch (err) { return false; }
      });
      if (match) {
        variantSelect.value = match.value;
        if (priceEl && match.dataset.price) priceEl.textContent = match.dataset.price;
        var addBtn = scope.querySelector('.product-page form .btn--full');
        if (addBtn) {
          addBtn.disabled = match.disabled;
          addBtn.textContent = match.disabled ? 'Sold out' : 'Add to cart';
        }
      }
    }

    pillInputs.forEach(function (input) {
      input.addEventListener('change', syncVariant);
    });
    if (!pillInputs.length) {
      /* dropdown mode: update price + button state straight from the select */
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        var addBtn = document.querySelector('.product-page form .btn--full');
        if (addBtn && opt) {
          addBtn.disabled = opt.disabled;
          addBtn.textContent = opt.disabled ? 'Sold out' : 'Add to cart';
        }
      });
    }
    syncVariant();

    variantSelect.dataset.bound = 'true';
  }

  /* ---------- Scroll reveal ----------
     Elements start at opacity:0 (see .reveal in base.css) and are only shown
     once .is-visible is added. This MUST be re-runnable: the theme editor
     re-renders a section's markup whenever a setting changes, replacing the
     old nodes with fresh ones that no observer is watching — which would
     otherwise leave them stuck at opacity:0 (invisible text). */
  function initReveals(scope) {
    var reveals = Array.prototype.slice.call(scope.querySelectorAll('.reveal:not(.is-visible)'));
    if (scope.classList && scope.classList.contains('reveal') && !scope.classList.contains('is-visible')) {
      reveals.push(scope);
    }
    if (!reveals.length) return;

    function showAll() {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    // In the theme editor, sections re-render constantly and may be off-screen
    // when injected. Never risk hiding merchant content there — show it outright.
    if (window.Shopify && window.Shopify.designMode) return showAll();
    if (!('IntersectionObserver' in window)) return showAll();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    initDrawer();
    initAccordions(root);
    initMegaMenus(root);
    initProduct(root);
    initReveals(root);
  }

  initAll(document);

  // Theme editor: re-init whenever a section is re-rendered or added.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
